





































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Aisle from "../../../store/entities/aisle";
import AppConsts from "../../../lib/appconst";
import util from "../../../lib/util";
import DateTimeMixin from '@/components/mixin/date-time-mixin';
import { mixins } from 'vue-class-component';
@Component
export default class ViewAisle extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  aisle: Aisle = new Aisle();
  spinShow = false;
  id: string ='';
  roomCode :string ='';
   onGoBack(){
      (this.$refs.aisleForm as any).resetFields();
      this.$emit("input", false);
      this.$root.$router.push({name: 'aisle'});
  }
   async getAisleInfo()
  {
       this.id =  this.$root.$router.currentRoute.params.id;
       this.roomCode =  this.$root.$router.currentRoute.params.roomCode;
      if(Util.isNull(this.id) || Util.isEmpty(this.id) || Util.isNull(this.roomCode) || Util.isEmpty(this.roomCode) )
        return;
      await this.$store.dispatch({
          type:'aisle/get',
          data: { id : this.id, roomCode: this.roomCode}
      }).then((result) => {
          this.aisle = result;
      });
  }
  async created(){
      await this.getAisleInfo();
  }
}
